import * as d3 from 'd3'

const lightColor = d3.rgb('white')
export const darkColor = d3.rgb('#583D8B')

export const color = d3.scaleOrdinal([darkColor, lightColor])
